// ----------------------------------------------------------------------
// Typed CSS custom-property names for the theme system.
//
// Usage in TSX/inline styles:
//   import { themeVar } from "theme/themeVars";
//   <div style={{ color: themeVar.colorText }} />
//
// Usage with getComputedStyle / setProperty:
//   import { themeProp } from "theme/themeVars";
//   root.style.setProperty(themeProp.colorBg, "#fff");
// ----------------------------------------------------------------------

/** Raw CSS property names (e.g. "--color-bg"). */
export const themeProp = {
  // Fonts
  fontHeading: "--font-heading",
  fontBody: "--font-body",
  fontSizeH1: "--font-size-h1",
  fontSizeH2: "--font-size-h2",
  fontSizeBody: "--font-size-body",
  fontSizeSmall: "--font-size-small",
  // Colors
  colorBg: "--color-bg",
  colorBannerBg: "--color-banner-bg",
  colorText: "--color-text",
  colorTextMuted: "--color-text-muted",
  colorPrimaryBtnBg: "--color-primary-btn-bg",
  colorPrimaryBtnText: "--color-primary-btn-text",
  colorSecondaryBorder: "--color-secondary-border",
  colorLink: "--color-link",
  colorCardText: "--color-card-text",
} as const;

/** CSS var() references (e.g. "var(--color-bg)") for use in style objects. */
export const themeVar = Object.fromEntries(
  Object.entries(themeProp).map(([key, prop]) => [key, `var(${prop})`])
) as { readonly [K in keyof typeof themeProp]: string };
